<template>
  <div>
    <titulo-relatorio-descontos-contrato />
    <b-row>
      <b-col cols="12" md="3" class="mt-3">
        <input-select-multiple
          ref="anoLetivoId"
          v-model="selecionados.anoLetivoId"
          :label="$t('ACADEMICO.ANO_LETIVO')"
          :options="opcoes.anosLetivos"
          required
        />
      </b-col>

      <b-col cols="12" md="3" class="mt-3">
        <input-select-multiple
          ref="tipoContrado"
          v-model="selecionados.tipoContrato"
          :label="$t('ACADEMICO.TIPO_CONTRATO')"
          :options="opcoes.tipoContratos"
          required
        />
      </b-col>

      <b-col cols="12" md="3" class="mt-3">
        <input-select-multiple
          ref="statusContrato"
          v-model="selecionados.status"
          :label="$t('ACADEMICO.STATUS_CONTRATO')"
          :options="opcoes.statusContratos"
          required
        />
      </b-col>

      <b-col cols="12" md="3" class="mt-3">
        <input-select-multiple
          ref="layoutDescontoContrato"
          v-model="selecionados.layout"
          :label="$t('ACADEMICO.LAYOUT_DESCONTO_CONTRATO')"
          :options="opcoes.layoutDescontosContratos"
          required
        />
      </b-col>

      <b-col cols="12" md="3" class="mt-3">
        <input-select-multiple
          ref="descontos"
          v-model="selecionados.descontoId"
          :label="$t('GERAL.DESCONTO')"
          :options="opcoes.descontos"
        />
      </b-col>

      <b-col cols="12" md="auto" class="mt-3">
        <b-button
          class="w-100 botao-acao-filtro"
          variant="info"
          @click="realizarImpressaoRelatorioDescontosParaContratos"
          v-if="podeVisualizar"
        >
          {{ $t('GERAL.GERAR_RELATORIO') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import pdf from '@/common/utils/pdf';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import DescontosService from '@/common/services/descontos/descontos.service';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';

// Components:
import { InputSelectMultiple } from '@/components/inputs';
import mensagem from '@/common/utils/mensagem';
import TituloRelatorioDescontosContrato from '@/views/academico/relatorios/relatorio-descontos-para-contratos/TituloRelatorioDescontosContrato';

export default {
  mixins: [Permissoes],
  components: {
    TituloRelatorioDescontosContrato,
    InputSelectMultiple,
  },
  data() {
    return {
      selecionados: {},
      opcoes: {
        anosLetivos: [],
        tipoContratos: [],
        statusContratos: [],
        layoutDescontosContratos: [],
        descontos: [],
      },
    };
  },

  mounted() {
    this.getAnosLetivos();
    this.getTipoContratos();
    this.getLayoutDescontoContrato();
    this.getStatusContratos();
    this.getDescontos();
  },
  methods: {
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    realizarImpressaoRelatorioDescontosParaContratos() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);

      const { anoLetivoId, tipoContrato, status, layout, descontoId } =
        this.selecionados;

      const objetoParaFiltro = {
        anoLetivoId: anoLetivoId.id,
        tipoContrato: tipoContrato.id,
        status: status.id,
        layout: layout.id,
        descontoId: descontoId?.id,
      };

      DescontosService.realizarImpressaoRelatorioDescontosParaContratos(
        objetoParaFiltro
      )
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);

            let blob = new Blob([bytes], { type: 'application/pdf' });

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getLayoutDescontoContrato() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('layout-contrato-desconto')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.layoutDescontosContratos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getStatusContratos() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('status-contrato')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));

          this.opcoes.statusContratos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getTipoContratos() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('tipo-contratos')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.tipoContratos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getAnosLetivos() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar()
        .then(({ data }) => {
          data = data.map((row) => {
            return {
              ...row,
              text: row.ano,
              value: row.id,
            };
          });

          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getDescontos() {
      this.$store.dispatch(START_LOADING);
      DescontosService.obterTodos()
        .then(({ data }) => {
          data = data.map((row) => {
            return {
              ...row,
              text: row.descricao,
              value: row.id,
            };
          });

          this.opcoes.descontos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
